export const workbenchFocusInputActivationType = "focus-input";
